import type { ChallengeInfo } from "../../../api/getChallengesForEmployee";

import { useSalesContext } from "../../../sales-context/SalesContext";
import { useChallenges } from "../challenges/api/useChallenges";
import { useIsPacingActive } from "./useIsPacingActive";

function hasEnrollmentChallenge(challenge: ChallengeInfo | null | undefined) {
    if (challenge) {
        return challenge.challengeType === "solo" || challenge.challengeType === "team";
    }
}

export function useWidgetVisibility() {
    const { partnerConfig, features } = useSalesContext();
    const { leaderboards } = partnerConfig;
    const { data: challengeData } = useChallenges();
    const showPacing = useIsPacingActive();

    const hasLeaderboards = leaderboards.length > 0;
    const shouldHideWidgetContainer = !hasLeaderboards && !features.isChallengeEnabled && !showPacing;
    const showLeftPanel =
        (features.isChallengeEnabled && challengeData?.some(hasEnrollmentChallenge)) || hasLeaderboards;
    const showStatsHeader = features.isExpertPerformanceDashboardEnabled;
    const showChallenges = features.isChallengeEnabled && features.isChallengesEnabled;
    const showTrophyCase = features.isChallengeEnabled && features.isChallengesEnabled;

    return {
        shouldHideWidgetContainer,
        showLeftPanel,
        showStatsHeader,
        showChallenges,
        showTrophyCase,
        showPacing,
        isChecklistSummaryEnabled: features.isChecklistSummaryEnabled,
        isExpertPerformanceDashboardEnabled: features.isExpertPerformanceDashboardEnabled,
        hasLeaderboards,
        leaderboards,
    };
}
